import ConfirmationPopupWithMutation from './ConfirmationPopupWithMutation';

export default ConfirmationPopupWithMutation;
